import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { Tracking } from "Types/api/Tracking";

/**
 * Patch Tracking request/success/failure
 */
export const patchTrackingRequest = actionCreator(
    "tracking/patch/request",
    (tracking: Tracking, uuid: string) => ({
        uuid,
        tracking,
    }),
    () => ({ route: API.Deal })
);

export const patchTrackingSuccess = actionCreator("tracking/patch/success");

export const patchTrackingFailure = actionCreator("tracking/patch/failure");

/**
 * Set Tracking (Used to set tracking values in store before we have a deal UUID)
 */
export const setTracking = actionCreator("tracking/set", (tracking: Tracking) => ({
    tracking,
}));
